module.exports = __webpack_public_path__ + "static/media/Portrait-10074.2ec48534.jpg";